export class GcpRestoreAccountAttributes {
    'serviceAccount';
    'hostProjectId';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "hostProjectId",
            "baseName": "hostProjectId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
